import React from 'react';
import { Button } from './ui/button';
import { Badge } from './ui/badge';
import { ArrowRight, Sparkles } from 'lucide-react';

export const Hero = () => {
  const handleCTA = (action) => {
    const toast = document.createElement('div');
    toast.textContent = `${action} feature coming soon!`;
    toast.className = 'fixed top-4 right-4 bg-amber-500 text-white px-6 py-3 rounded-lg shadow-lg z-50';
    document.body.appendChild(toast);
    setTimeout(() => toast.remove(), 3000);
  };

  return (
    <section
      id="hero"
      className="relative bg-white overflow-hidden"
      data-testid="hero-section"
    >
      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-24 lg:py-32">
        <div className="text-center">
          {/* Badge */}
          <Badge
            className="inline-flex items-center gap-2 rounded-full bg-black text-white px-4 py-1.5 text-sm font-semibold mb-6"
            data-testid="open-badge"
          >
            <Sparkles className="h-4 w-4" />
            2026 Competition Now Open
          </Badge>

          {/* Main Heading */}
          <h1
            className="mt-4 text-4xl sm:text-5xl lg:text-7xl font-extrabold tracking-tight text-gray-900 max-w-5xl mx-auto"
            data-testid="hero-title"
          >
            The World's Leading{' '}
            <span className="relative inline-block">
              <span className="relative z-10">Exhibition Stand</span>
              <span className="absolute bottom-2 left-0 w-full h-3 bg-amber-400 -z-0" aria-hidden="true"></span>
            </span>{' '}
            Awards
          </h1>

          {/* Subtitle */}
          <p
            className="mt-6 max-w-2xl mx-auto text-lg sm:text-xl text-gray-600 leading-relaxed"
            data-testid="hero-subtitle"
          >
            Recognizing excellence, creativity, and innovation in exhibition stand design across the globe
          </p>

          {/* Stats Row */}
          <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-6 max-w-4xl mx-auto" data-testid="stats-row">
            {[
              { value: '50+', label: 'COUNTRIES' },
              { value: '20+', label: 'INTERNATIONAL JURY' },
              { value: '500+', label: 'PARTICIPANTS' },
              { value: '8', label: 'CATEGORIES' }
            ].map((stat, index) => (
              <div key={index} className="text-center" data-testid={`stat-${index}`}>
                <div className="text-4xl sm:text-5xl font-bold text-gray-900">{stat.value}</div>
                <div className="mt-2 text-xs sm:text-sm font-semibold text-gray-500 tracking-wider">
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};